export function isInt(value) {
    return (
        !isNaN(value) &&
        parseInt(Number(value)) == value &&
        !isNaN(parseInt(value, 10))
    );
}

export const isset = (param) => typeof param !== 'undefined' && param !== null;
